import axios from 'axios'
import { AuthCache } from 'constants/index'
import Cookies from 'js-cookie'
import RouteList from 'pages/Routes'
import queryString from 'query-string'

const handle = axios.create({
  baseURL: process.env.REACT_APP_API,
  timeout: 60000,
  headers: {
    'content-type': 'application/json',
  },
  paramsSerializer: (params) => queryString.stringify(params),
})

export const addToken = (token) => {
  Cookies.set(AuthCache.AUTH_TOKEN_CACHE, token)
  handle.defaults.headers.common.Authorization = `Bearer ${token}`
}

export const removeToken = () => {
  delete handle.defaults.headers.common.Authorization
  Cookies.remove(AuthCache.AUTH_TOKEN_CACHE)
}

handle.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    error.message = error.response.data.message
    error.data = error.response.data.errors

    if (error.response && error.response.status === 401) {
      if (error.message === "Invalid credentials") return Promise.reject(error)

      removeToken()
      window.location.href = RouteList.home
      setTimeout(() => window.location.reload(), 500)
    }
    return Promise.reject(error)
  }
)

export default handle
